import type { GenerationOptions, GenerationResponse } from './types';

export const generateTextToImageGPTImage1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gpt-image-1',
    generationType: 'image'
  });
};

export const generateTextToImageDALLE3 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'dall-e-3',
    generationType: 'image'
  });
};

export const generateTextToImageDALLE2 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'openai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'dall-e-2',
    generationType: 'image'
  });
};

export const generateTextToImageGeminiProVision = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-pro-vision',
    generationType: 'image'
  });
};

export const generateTextToImageGemini15Flash = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-1.5-flash',
    generationType: 'image'
  });
};

export const generateTextToImageGemini15Pro = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-1.5-pro',
    generationType: 'image'
  });
};

export const generateTextToImageGemini25Pro = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-pro',
    generationType: 'image'
  });
};

export const generateTextToImageGemini25Flash = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-flash',
    generationType: 'image'
  });
};

export const generateTextToImageGemini25FlashImage = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'gemini',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'gemini-2.5-flash-image-preview',
    generationType: 'image'
  });
};

export const generateTextToImageNanoBanana = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'fal-ai/nano-banana/edit',
    generationType: 'image'
  });
};

export const generateTextToImageFastSDXL = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'fast-sdxl',
    generationType: 'image'
  });
};

export const generateTextToImageFluxSchnell = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'flux-schnell',
    generationType: 'image'
  });
};

export const generateTextToImageFluxDev = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'fal_ai',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'flux-dev',
    generationType: 'image'
  });
};

// Luma Labs Text to Image generators
export const generateTextToImageRayFlash2 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'lumalabs',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'ray-flash-2',
    generationType: 'image'
  });
};

export const generateTextToImageRay1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'lumalabs',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'ray-1',
    generationType: 'image'
  });
};

export const generateTextToImagePhotonFlash1 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'lumalabs',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'photon-flash-1',
    generationType: 'image'
  });
};

export const generateTextToImageSeedReal4 = async (
  options: GenerationOptions,
  generateVisual: any
): Promise<GenerationResponse> => {
  return await generateVisual({
    prompt: options.prompt,
    promptId: options.promptId,
    aiProvider: 'byteplus',
    style: options.style,
    quality: options.quality,
    size: options.size,
    modelId: 'seedreal-4.0',
    generationType: 'image'
  });
};